/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointtwobold2Inputs */

const ja_home_agency_pointtwobold2 = /** @type {(inputs: Home_Agency_Pointtwobold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINはゲーマーのニーズと想いを深く理解しています。`)
};

const en_home_agency_pointtwobold2 = /** @type {(inputs: Home_Agency_Pointtwobold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We understand Gamers.`)
};

/**
* | output |
* | --- |
* | "We understand Gamers." |
*
* @param {Home_Agency_Pointtwobold2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointtwobold2 = /** @type {((inputs?: Home_Agency_Pointtwobold2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointtwobold2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointtwobold2(inputs)
	return en_home_agency_pointtwobold2(inputs)
});
export { home_agency_pointtwobold2 as "home_agency_pointTwoBold" }